import styled from 'styled-components'

const ShareSuccessStyled = styled.div`
  img {
    width: 100%;
    height: auto;
  }
`

function ShareSuccess() {
  return (
    <ShareSuccessStyled>
      <picture className="img">
        <source srcSet="/images/projects/landing/share-your-succes.webp" type="image/webp" />
        <source srcSet="/images/projects/landing/share-your-succes.png" type="image/png" />
        <img
          src="/images/projects/landing/share-your-succes.png"
          alt="Comparte y aprende con los proyectos de la comunidad en el canal de discord"
          width="608"
          height="568"
          loading="lazy"
        />
      </picture>
    </ShareSuccessStyled>
  )
}

export default ShareSuccess
